const AGENTES = {
  OZON: "eriOKuTfDFP2oEnrm1Iq",
  WOW: "Ndm5mv0XysZryOeQbdfX",
};

export default AGENTES;
